import { WorkspacesListingItem } from '@futrli-sdk/workspaces';
import { APIClients } from '@futrli/shared-services';
import { API_PATHS, getAxiosResponseData, interpolatePathParams } from '@futrli/shared-services';

/**
 * Fetches a list of workspaces with their respective details.
 *
 * @returns {Promise<WorkspacesListingItem[]>}
 */
export const fetchWorkspacesListing = async (): Promise<WorkspacesListingItem[]> => {
  const path = interpolatePathParams(API_PATHS.ALL_WORKSPACES_DATA, {});
  const response = await APIClients.getAPIClient().makeRequest({
    payload: {
      request: {
        url: path
      }
    }
  });
  return getAxiosResponseData(response.data);
};
